import { Observable } from "rxjs";
import { config } from "../../config/config";
import { utilService } from "../utils";

/**
 * Api services for email component
 */
export const sendEmailsService = {
  sendEmails,
  saveEmailText,
  getEmailText,
  updateEmailText,
};

function getEmailText(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.weeklyemailtext, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        console.log(error);
        // if (error.status === 401) {
        //   window.location.reload();
        // }
      });
  });
}

function saveEmailText(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.weeklyemailtext, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function updateEmailText(data) {
  console.log("passed");
  return Observable.create((observer) => {
    fetch(
      config.api_url +
        config.url.weeklyemailtext +
        data.data.weeklyemailtextUid,
      {
        method: "PUT",
        headers: {
          Authorization: data.token,
        },
        body: JSON.stringify(data.data),
      }
    )
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function sendEmails(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.send_emails, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        console.log("result....", result);
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        // console.log(error)
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
        // observer.complete()
      });
  });
}
